import React from "react";
import { Header } from "../../../components/Header";
import "./styles.less";
import { Footer } from "../../../components/FooterV2";
import { SolutionIndustrySupport } from "../../../blocks/solution-industry-support";
import { CommonPageLink } from "../../../blocks/common-page-link";
import { HomeTryOn } from "../../../blocks/home-try-on";
import { useTranslation } from "react-i18next";
import { SolutionIndustryBanner } from "../../../blocks/solution-industry-banner";
import { SolutionSceneIntro } from "../../../blocks/solution-scene-intro";
import { SolutionSceneValue } from "../../../blocks/solution-scene-value";
import { SolutionSceneScreen } from "../../../blocks/solution-scene-screen";
import { Helmet } from "react-helmet";
import { Notice } from "../../../components/Notice";

export const CognitoPage = () => {
  const { t } = useTranslation();
  const select_list = [
    {
      subLabel: t("solution.cognito.value.item1.title"),
      content: (
        <>
          <div className="item-title">
            {t("solution.cognito.value.item1.subtitle")}
          </div>
          <div className="item-list">
            {t("solution.cognito.value.item1.list1")}
          </div>
          <div className="item-list">
            {t("solution.cognito.value.item1.list2")}
          </div>
          <div className="item-list">
            {t("solution.cognito.value.item1.list3")}
          </div>
          <div className="item-list">
            {t("solution.cognito.value.item1.list4")}
          </div>
        </>
      ),
      imgUrl: t("solution.cognito.value.item1.img"),
      alt: "全面替代Cognito User Pool",
      // "//files.authing.co/authing-website/solution-cognito-framework-design.png",
    },
    {
      subLabel: t("solution.cognito.value.item2.title"),
      content: (
        <>
          <div className="item-title">
            {t("solution.cognito.value.item2.subtitle")}
          </div>
          <div className="item-list">
            {t("solution.cognito.value.item2.list1")}
          </div>
          <div className="item-list">
            {t("solution.cognito.value.item2.list2")}
          </div>
          <div className="item-list">
            {t("solution.cognito.value.item2.list3")}
          </div>
        </>
      ),
      imgUrl:
        // "//files.authing.co/authing-website/solution-cognito-login-token.png",
        t("solution.cognito.value.item2.img"),
      alt: "国产Cognito User Pool",
    },
    {
      subLabel: t("solution.cognito.value.item4.title"),
      content: t("solution.cognito.value.item4.subtitle"),
      imgUrl:
        // "//files.authing.co/authing-website/solution-cognito-identity-pool-v2.png",
        t("solution.cognito.value.item4.img"),
      alt: "国产化Cognito User Pool",
    },
    {
      subLabel: t("solution.cognito.value.item3.title"),
      content: t("solution.cognito.value.item3.subtitle"),
      imgUrl:
        // "//files.authing.co/authing-website/solution-cognito-api-gateway.png",
        t("solution.cognito.value.item3.img"),
      alt: "国产AWS Cognito",
    },
  ];
  const pagesLink = [
    {
      title: t("common.pageLink.comp.title"),
      description: t("common.pageLink.comp.description"),
      imgurl: "/page-link-comp.png",
      jumpLink: "/learn/guard",
      defaultImg: "//files.authing.co/authing-website/page-link-icon-comp.svg",
      checkedImg:
        "//files.authing.co/authing-website/page-link-icon-default-comp.svg",
    },
    {
      title: t("common.pageLink.mfa.title"),
      description: t("common.pageLink.mfa.description"),
      imgurl: "/page-link-mfa.png",
      jumpLink: "/mfa",
      defaultImg: "//files.authing.co/authing-website/page-link-icon-mfa.svg",
      checkedImg:
        "//files.authing.co/authing-website/page-link-icon-default-mfa.svg",
    },
    {
      title: t("common.pageLink.verify.title"),
      description: t("common.pageLink.verify.description"),
      imgurl: "/page-link-verify.png",
      jumpLink: "/verify",
      defaultImg:
        "//files.authing.co/authing-website/page-link-icon-verify.svg",
      checkedImg:
        "//files.authing.co/authing-website/page-link-icon-default-verify.svg",
    },
    {
      title: t("common.pageLink.database.title"),
      description: t("common.pageLink.database.description"),
      imgurl: "/page-link-database-connection.png",
      jumpLink: "/database-connection",
      defaultImg:
        "//files.authing.co/authing-website/page-link-icon-database.svg",
      checkedImg:
        "//files.authing.co/authing-website/page-link-icon-default-database.svg",
    },
  ];
  return (
    <div className="cognito-page">
      <Helmet>
        <title>
          身份云 IDaaS 已替代AWS Cognito，Cognito 中国版-Authing 身份云
        </title>
      </Helmet>
      <Header mode="light" hasNotice />
      <SolutionIndustryBanner
        title={t("solution.cognito.banner.title")}
        subtitle={t("solution.cognito.banner.subtitle")}
        imgUrl="//files.authing.co/authing-website/solution-banner-aws-v2.png"
      />
      <SolutionSceneIntro
        scene={
          <>
            <div className="item">{t("solution.cognito.intro.descript1")}</div>
            <div className="item">{t("solution.cognito.intro.descript2")}</div>
          </>
        }
      />
      <SolutionSceneValue value={t("solution.cognito.value.title")} />
      <SolutionSceneScreen list={select_list} />
      <SolutionIndustrySupport
        supportTitle={t("solution.scene.title-support")}
        noLastBlock
      />
      <CommonPageLink pagesLink={pagesLink} />
      <HomeTryOn hasBg />
      <Footer />
    </div>
  );
};
